const round = (number, decimalPlacesCount) => (
  Math.round((number + Number.EPSILON) * (10 ** decimalPlacesCount)) / (10 ** decimalPlacesCount)
)

export default round
